import { Injectable, computed, signal } from '@angular/core';
import { Subject } from 'rxjs';

import { AdminNote } from '../models/admin-note.model';

export interface AdminNotesFabSubject {
  subjectType: 'user' | 'group';
  subjectId: string;
  subjectName: string;
}

@Injectable({ providedIn: 'root' })
export class AdminNotesFabService {
  private readonly subjectSignal = signal<AdminNotesFabSubject | null>(null);
  private readonly notesSignal = signal<AdminNote[]>([]);
  private readonly openSubject = new Subject<AdminNotesFabSubject>();

  readonly subject = computed(() => this.subjectSignal());
  readonly unresolvedCount = computed(() => this.notesSignal().filter(note => !note.isResolved).length);
  readonly open$ = this.openSubject.asObservable();

  setSubject(subject: AdminNotesFabSubject | null): void {
    this.subjectSignal.set(subject);

    if (!subject) {
      this.notesSignal.set([]);
    }
  }

  setNotes(notes: AdminNote[]): void {
    this.notesSignal.set(notes);
  }

  requestOpen(): void {
    const subject = this.subjectSignal();
    if (subject) {
      this.openSubject.next(subject);
    }
  }

  clear(): void {
    this.subjectSignal.set(null);
    this.notesSignal.set([]);
  }
}
